import React from "react";
import styled from "styled-components";
import { saturate, lighten } from "polished";
import { Container, Row, Col } from "react-bootstrap";

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import { Title, Section, Box, Text } from "../../components/Core";
import { StoreBadgeBar } from "../../components/StoreBadge";

import { device } from "../../utils";

const SectionStyled = styled(Section)`
  background-image: ${({ theme }) => `radial-gradient(
    circle 961px at 49.94% 0%,
    ${lighten(0.114, saturate(0.0911, theme.colors.ash))} 0%,
    ${theme.colors.ash} 100%
  );`};
`;

const ImgRight = styled(Box)`
  position: relative;
  left: -100px;
  @media ${device.md} {
    position: absolute;
    top: 0;
    max-width: 80%;
    min-width: 80%;
    right: auto;
    left: 0;
    transform: translateX(25%);
  }
`;

const Hero = () => {

  const data = useStaticQuery(graphql`
    query {
      tablet_hero: file(relativePath: { eq: "tablet_hero.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      {/* <!-- Hero Area --> */}
      <SectionStyled className="position-relative">
        <div className="pt-5"></div>
        <Container>
          <Row className="justify-content-center align-items-center position-relative">
            <Col md="5" className="order-md-2 position-static">
              <ImgRight>
                <Box
                  data-aos="fade-left"
                  data-aos-duration="750"
                  data-aos-delay="1000"
                  data-aos-once="true"
                >
                  <Img fluid={data.tablet_hero.childImageSharp.fluid} />
                </Box>
              </ImgRight>
            </Col>
            <Col md="7" className="order-md-1">
              <div
                data-aos="fade-right"
                data-aos-duration="750"
                data-aos-delay="500"
                data-aos-once="true"
              >
                <Box py={[null, null, null, 5]} pr={5} pt={[4, null]}>
                  <Title variant="hero" color="light">
                    Hello.<br className="d-none d-sm-block" />
                    I'm Opqo.
                  </Title>
                  <Text mt={4} mb={1} color="light" opacity={0.7}>
                    [ op-koh ]
                  </Text>
                  <Text mb={4} color="light" opacity={0.7}>
                    <i>n.</i> A simpler approach to mobile Maximo.
                  </Text>
                  <div className="d-flex flex-column align-items-start pt-3">
                    <StoreBadgeBar />
                  </div>
                </Box>
              </div>
            </Col>
          </Row>
        </Container>
      </SectionStyled>
    </>
  );
};

export default Hero;
